import { fromCallback } from 'xstate';

import { CorrelatedLogger } from '@eluve/logger-main';
import { LockLease, acquireLease } from '@eluve/navigator-utils';

import { TranscriptionMachineEvents } from '../machines/transcription-machine/types';

export const lockManagerActor = fromCallback<
  TranscriptionMachineEvents,
  {
    logger: CorrelatedLogger;
  }
>(({ input, receive }) => {
  const { logger } = input;

  const acquiredLocks = new Map<LockLease['key'], LockLease['release']>();

  receive((event) => {
    switch (event.type) {
      case 'fileSystem.fileCreated': {
        logger('info', 'Acquiring lock lease for file', {
          fileName: event.fileName,
        });
        acquireLease(event.fileName)
          .then((result) => {
            logger('info', 'Acquired lock lease for file', {
              fileName: result?.key,
            });
            if (typeof result?.release === 'function') {
              acquiredLocks.set(event.fileName, result.release);
            }
          })
          .catch((error) => {
            logger('error', 'Failed to acquire lock lease for file', {
              fileName: event.fileName,
              error,
            });
          });
        break;
      }
      case 'fileSystem.fileReady': {
        logger('info', 'Releasing lock lease for file', {
          fileName: event.fileName,
        });
        acquiredLocks.get(event.fileName)?.();
        acquiredLocks.delete(event.fileName);
        break;
      }
    }
  });
  return () => {
    logger('info', 'Called lockManagerActor cleanup', {
      totalLocks: acquiredLocks.size,
    });
    for (const [key, value] of acquiredLocks) {
      logger('info', 'Cleaning up acquired lock', {
        fileName: key,
      });
      value?.();
    }
  };
});
